'use client';

  import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

  interface PreloaderContextValue {
    isVisible: boolean;
    label: string;
    show: (label?: string) => void;
    hide: () => void;
  }

  const PreloaderContext = createContext<PreloaderContextValue>({
    isVisible: false,
    label: 'Loading',
    show: () => {},
    hide: () => {},
  });

  export const usePreloader = () => useContext(PreloaderContext);

  export function PreloaderProvider({ children }: { children: ReactNode }) {
    const [isVisible, setIsVisible] = useState(false);
    const [label, setLabel] = useState('Loading');

    const show = useCallback((label = 'Loading') => {
      setLabel(label);
      setIsVisible(true);
    }, []);

    const hide = useCallback(() => setIsVisible(false), []);

    return (
      <PreloaderContext.Provider value={{ isVisible, label, show, hide }}>
        {children}
      </PreloaderContext.Provider>
    );
  }
  